<template>
    <div>MyTask Page</div>
</template>

<script>
export default {
    name: 'mytask',
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Body/Mytask.vue